import React from 'react';

import Container from './components/Container';
import Copyright from './components/Copyright';
import LinksList from './components/LinksList';
import ListItem from './components/ListItem';
import Link from './components/Link';

const footerMenuItems = [
  {
    name: 'About',
    path: '/about',
  },
  {
    name: 'Privacy Policy',
    path: '/privacy-policy',
  },
  {
    name: 'Terms and Conditions',
    path: '/terms-and-conditions',
  },
  {
    name: 'Cookies',
    path: '/cookies',
  },
  {
    name: 'FAQ',
    path: '/faq',
  },
  {
    name: 'Contact us',
    path: '/contact',
  },
];

const Footer = () => (
  <Container>
    <Copyright>
      © {new Date().getFullYear()}. Luminaire Broker. All Rights Reserved.
    </Copyright>
    <LinksList>
      {footerMenuItems.map((item, i) => {
        return (
          <ListItem key={i}>
            <Link href={item.path}>{item.name}</Link>
          </ListItem>
        );
      })}
    </LinksList>
  </Container>
);

export default Footer;
